import http from './http.js';
import { isLogin } from './index.js';
import sha256 from 'crypto-js/sha256';
const baseUrl = 'https://aistudio.cloud.tencent.com/' ;
const defaultUrl = 'https://aistudio.cloud.tencent.com/demo-user/capi/getResult/' ;

/**
 * 处理 configKey 参数，将具有相同 configKey 的字段合并成一个 JSON 字符串
 * @param {Object} payload - 请求参数
 * @param {Array} paramsList - 参数配置列表
 * @returns {Object} 处理后的 payload
 */
export function processConfigKeyParams(payload, paramsList) {
  if (!paramsList || paramsList.length === 0) return payload;
  
  const result = { ...payload };
  const configKeyMap = {}; // 用于收集相同 configKey 的字段
  
  paramsList.forEach(param => {
    if (param.configKey) {
      const configKey = param.configKey;
      const fieldKey = param.key;
      
      if (result[fieldKey] !== undefined) {
        if (!configKeyMap[configKey]) {
          configKeyMap[configKey] = {};
        }
        
        // 如果 key 和 configKey 相同，且值已经是字符串（JSON格式），则解析后合并
        if (fieldKey === configKey && typeof result[fieldKey] === 'string') {
          try {
            const existingObj = JSON.parse(result[fieldKey]);
            configKeyMap[configKey] = { ...configKeyMap[configKey], ...existingObj };
          } catch (e) {
            // 解析失败，直接使用原值
            configKeyMap[configKey][fieldKey] = result[fieldKey];
          }
        } else {
          // 正常情况，使用 key 作为字段名
          configKeyMap[configKey][fieldKey] = result[fieldKey];
        }
        delete result[fieldKey];
      }
    }
  });
  
  // 将收集到的 configKey 对象转换为 JSON 字符串
  Object.keys(configKeyMap).forEach(configKey => {
    result[configKey] = JSON.stringify(configKeyMap[configKey]);
  });
  
  return result;
}

// ocr 文字识别
export async function baseOcrRequest({cmd,data,isExample = false,fileType,module,checkLogin = true,config,paramsList}) {
  let url = isExample ?  'demo-common/democase/getDemoResultByDefaultImage' : 'demo-user/capi/getResult/';
  let payload = {
    ...data
  }
  
  // 处理 configKey 参数（通用处理）
  if (paramsList) {
    payload = processConfigKeyParams(payload, paramsList);
  }
  
  if(cmd === 'ReconstructDocument' ){
    payload.Config = {
      EnableInsetImage: data.EnableInsetImage === '1' ? true : false
    };
    delete payload.EnableInsetImage;
  }else if(cmd === 'ReconstructDocumentDemo' ){
    payload.FileType = fileType.toUpperCase()
  }

  return http.post({
    url: `${baseUrl}${url}`,
    cmd,
    data:payload,
    module,
    checkLogin,
    config
  });
}
export async function chartOcrRequest(data,isExample = true) {
  let url = isExample ?  'demo-common/democase/getDemoResultByDefaultImage' : 'demo-user/capi/getResult/'
  return http.post({
    url: `${baseUrl}${url}`,
    cmd:'ChatOCR',
    data,
  });
}
export async function chartOcrFeedBackRequest(data) {
  return http.post({
    url: defaultUrl,
    cmd:'ChatOCRDemoFeedBack',
    data,
  });
}
export  async function getProductList(){
  const url = 'demo-common/getProductConfig';
  return http.demoPost({
    url: `${baseUrl}${url}`
  });
}

export  function  pollApi(payload, interval, maxPollCount = 10) {
    let pollCount = 0;
    let canceled = false;
    
    return {
        start: new Promise((resolve, reject) => {
            const executePoll = () => {
                // 检查是否已被取消
                if (canceled) return;
                // 检查是否达到最大轮询次数
                if (pollCount >= maxPollCount) {
                    reject({
                      msg: '网络异常，请重试'
                    });
                    return;
                }
                
                pollCount++;
                
                baseOcrRequest(payload)
                    .then(response => {
                        if (canceled) return;
                        if(response.Error || response.error || response.JobStatus === 'FAIL'){
                          reject(response)
                        }else if (response.JobStatus === 'DONE') {
                        // 检查是否满足成功条件
                            resolve(response);
                        } else {
                            // 继续下一次轮询
                            resolve(response);
                            setTimeout(executePoll, interval);
                        }
                    })
                    .catch(error => {
                        if (canceled) return;
                        reject(error)
                        // 遇到错误继续尝试
                        // setTimeout(executePoll, interval);
                    });
            };
            
            // 开始第一次轮询
            executePoll();
        }),
        cancel: () => {
            canceled = true;
        }
    };
}

export async function getRecentMenu(data) {
  const { QCLogin } = window;
  if(!isLogin) return
  let uin = QCLogin.getUin();
  return http.post({
    url: defaultUrl,
    cmd:'QueryUserInterfaceHistoryAccessRecordForDemo',
    data:{
      ...data,
      Sid:sha256(uin).toString()
    },
    checkLogin:false
  });
}

export async function addRecentMenu(data) {
  const { QCLogin } = window;
  if(!isLogin) throw({
    error: true
  })
  let uin = QCLogin.getUin();

  return http.post({
    url: defaultUrl,
    cmd:'AddUserInterfaceHistoryAccessRecordForDemo',
    data:{
      ...data,
      Sid:sha256(uin).toString()
    },
    checkLogin:false
  });
  
}